import "../../styles/blocks/blog-posts/blog-posts-filter.scss";

import React, {useEffect, useRef} from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import PageHeader from "../../components/PageHeader";

const BlogPostsFilter = ({ title, categories, currentCategorySlug, pageHeader }) => {
	const filtersWrapper = useRef(null);
	const activeFilter = useRef(null);

	useEffect(() => {
		if (!activeFilter.current && !filtersWrapper.current) return;

		const x = activeFilter.current.offsetLeft - window.innerWidth / 2 + activeFilter.current.offsetWidth / 2;
		filtersWrapper.current.scrollTo(x, 0);
	});

	return (
		<div className="blog-posts-filter">
			<div className="blog-posts-filter__wrapper">
				<div className="container">
					<PageHeader
						{...pageHeader}
						title={pageHeader?.title || title}
						implemented={true}
						className={"section-title section-title--large blog-posts-filter__title"}
						isGeneral={true}
					/>
				</div>

				<div className="container blog-posts-filter__list-container">
					{Boolean(categories.length) && (
						<div className="blog-posts-filter__list-wrapper" ref={filtersWrapper}>
							<div className="blog-posts-filter__list">
								<div className="blog-posts-filter__items">
									{currentCategorySlug === "" ? (
										<div className="blog-posts-filter__item blog-posts-filter__item--active" ref={activeFilter}>
											Latest Articles
										</div>
									) : (
										<Link to={`/blog/`} className="blog-posts-filter__item">
											Latest Articles
										</Link>
									)}

									{categories.map(({ id, name, slug }) => {
										const isActiveLink = slug === currentCategorySlug;

										return (
											isActiveLink ? (
												<div key={id} className="blog-posts-filter__item blog-posts-filter__item--active" ref={activeFilter}>
													{name}
												</div>
											) : (
												<Link key={id} to={`/blog/category/${slug}/`} className="blog-posts-filter__item">
													{name}
												</Link>
											)
										);
									})}
								</div>
							</div>
						</div>
					)}
				</div>
			</div>
		</div>
	);
}

BlogPostsFilter.propTypes = {
	title: PropTypes.string.isRequired,
	categories: PropTypes.array.isRequired,
	currentCategorySlug: PropTypes.string
};

export default BlogPostsFilter;
